import { isTenantFeatureEnabled } from '@/config/tenantFeatures.js';
import {
  can,
  canAny,
  getPermissionCodeForPath,
  getPermissionCodes,
  getPermissionCodesForPath,
} from '@/security/access.js';

const DASHBOARD_CANDIDATES = [
  {
    path: '/cargas/dashboard',
    featureCode: 'CARGAS.DASHBOARD',
    permissionHints: ['GUIAS_VER', 'GUIAS_BUSCAR'],
    roleHints: ['operaciones', 'trafico', 'recepcion', 'reparto', 'cargas'],
  },
  {
    path: '/tesoreria/dashboard',
    featureCode: 'TESORERIA',
    permissionHints: ['COBRANZAS_VER', 'COBRANZAS_REGISTRAR', 'PAGOS_PROVEEDORES_VER'],
    roleHints: ['tesoreria', 'cobranzas', 'finanzas'],
  },
  {
    path: '/ctasctes/cuenta-corriente-clientes/resumen-de-cuenta',
    featureCode: 'CTAS_CTES.CLIENTES',
    permissionHints: ['CUENTA_CORRIENTE_VER', 'CUENTA_CORRIENTE_VER_GLOBAL'],
    roleHints: ['ctas ctes', 'cuentas corrientes'],
  },
  {
    path: '/gerencial/dashboard',
    featureCode: 'GERENCIAL.DASHBOARD',
    permissionHints: ['REPORTES_VER', 'REPORTES_COBRANZAS_VER'],
    roleHints: ['gerencial'],
  },
];

function getRoleNames(user) {
  return [user?.rol, ...(Array.isArray(user?.roles) ? user.roles : [])]
    .map(role => String(role?.codigo || role?.nombre || role || '').trim().toLowerCase())
    .filter(Boolean);
}

function scoreCandidate(candidate, user) {
  const permissions = getPermissionCodes(user);
  const roles = getRoleNames(user);
  const permissionScore = candidate.permissionHints.some(permission => permissions.has(permission)) ? 10 : 0;
  const roleScore = candidate.roleHints.some(role => roles.includes(role)) ? 100 : 0;
  return roleScore + permissionScore;
}

function isAccessible(candidate, user, tenant) {
  const routePermission = getPermissionCodeForPath(candidate.path);
  const routePermissions = getPermissionCodesForPath(candidate.path);
  const routeAllowed = !routePermission || can(user, routePermission) || canAny(user, routePermissions);
  const candidateAllowed = !candidate.permissionHints.length || canAny(user, candidate.permissionHints);

  return isTenantFeatureEnabled(tenant, { featureCode: candidate.featureCode })
    && routeAllowed
    && candidateAllowed;
}

/**
 * Chooses a dashboard the authenticated user can actually open. Route permissions
 * follow RouteAccessGuard, while unguarded dashboards use their module's relevant
 * permission set so they are not offered to unrelated user profiles.
 */
export function getLoginLandingRoute(user, tenant) {
  return DASHBOARD_CANDIDATES
    .map((candidate, index) => ({ candidate, index }))
    .filter(({ candidate }) => isAccessible(candidate, user, tenant))
    .sort((left, right) => scoreCandidate(right.candidate, user) - scoreCandidate(left.candidate, user) || left.index - right.index)[0]
    ?.candidate.path || '/';
}

export function getLocationPath(location) {
  if (!location || typeof location !== 'object' || !location.pathname || location.pathname === '/login') {
    return null;
  }
  return `${location.pathname}${location.search || ''}${location.hash || ''}`;
}
